import { SSPageDataLayerObject } from "@pages/ShieldStarter/DataLayer/DataLayer.model";
import { get } from "lodash";


export class CCPPageDataLayerObject extends SSPageDataLayerObject{}

export class CCPUserDataLayerObject {
  person={
    relationship:"",
    age:""
  }
  constructor(data: any){
    this.person = get(data, "person", {
      age: "",
      relationship:""
    });
  }
}

export class CCPCTADataLayerObject {
    ctaText="";
    ctaType="";
  constructor(data: any) {
    this.ctaText = get(data, "ctaText", "");
    this.ctaType = get(data,"ctaType", "")
  }
}

export class CCPAcquisitionDataLayerObject {
  insurance = {
    paymentOptions: "",
    premium: "",
  };
  customer = {
    marketingOptIn: "",
    DOB: "",
    servicingMode: ""
  };
  product = {
    prodName: "Cancer Cover Plus II",
    prodID: "CCPII",
    premiumfrequency: "",
    policyID:""
  };

  constructor(data: any) {
    this.customer = get(data, "customer", {
      DOB: "",
      marketingOptIn: "",
    });

    this.product = get(data, "product", {
      premiumfrequency: "",
      prodName: "Cancer Cover Plus II",
      prodID: "CCPII",
      policyID:""
    });

    this.insurance = get(data, "insurance", {
      paymentOptions: "",
      premium: "",
    });
  }
}
// digitalData.form.field.Gender
// digitalData.form.error.fieldLabels
// digitalData.form.error.messages
// digitalData.form.error.numErrors
// digitalData.form.name

export class CCPFormDataLayerObject {
  name=""
  field={
    Gender: ''
  }
  error={
    fieldLabels:[],
    messages:[],
    numErrors:"0"
  }

  constructor(data: any) {
    this.name = get(data, "name", "");
    this.field =  get(data, 'field', {Gender:""})
    this.error = get(data, 'error', {fieldLabels:[], messages:[], numErrors:0})
  }
}


export class CCPDataLayer {
  public page: CCPPageDataLayerObject;
  public acquisition: CCPAcquisitionDataLayerObject;
  public form: CCPFormDataLayerObject;
  public user: CCPUserDataLayerObject;
  public cta: CCPCTADataLayerObject;
  constructor(initialData: any) {
    this.page = get(initialData, "page", {});
    this.acquisition = get(initialData, "acquisition", {});
    this.form = get(initialData, "form", {});
    this.user = get(initialData, 'user',{})
    this.cta = get(initialData, 'cta',{})
  }
}

